/**
 * Nhóm chứng từ thêm nhanh
 */
export default {
  Treasury: 1, // Kho bạc
  CA: 2, // Tiền mặt
  BA: 3, // Tiền gửi
  FA: 4, // Tài sản cố định
  InventoryItem: 5, // Kho
  GL: 6 // Tổng hợp
};
